import { Typography } from 'app/shared/components/Typography/Typography';
import styled from 'styled-components';

export const TitleSt = styled(Typography).attrs({ variant: 'h2' })`
  margin-top: 3rem;
`;
